<template>
    <a :href="link || null"
       class="mobile-menu-action"
       :target="link ? isExternal ? '_blank' : '_self' : null">
        <div class="mobile-menu-action__icon">
            <component :is="icon" />
        </div>

        <div class="mobile-menu-action__content">
            <div class="mobile-menu-action__title">
                {{ title }}
            </div>
            <div class="mobile-menu-action__description">
                {{ description }}
            </div>
        </div>

        <div class="mobile-menu-action__arrow">
            <IconChevron />
        </div>
    </a>
</template>

<script>
import IconArrowRight from '@/sections/MobileMenu/Icons/IconArrowRight';
import IconChevron from '@/sections/MobileMenu/Icons/IconChevron.vue';
import IconDownload from '@/sections/MobileMenu/Icons/IconDownload';
import IconSearch from '@/sections/MobileMenu/Icons/IconSearch.vue';
import IconTelegram from '@/sections/MobileMenu/Icons/IconTelegram.vue';

export default {
    name: 'MobileMenuAction',

    components: {
        IconArrowRight,
        IconChevron,
        IconDownload,
        IconSearch,
        IconTelegram
    },

    props: {
        title      : String,
        description: String,
        icon       : String,
        link       : String,
        isExternal : Boolean,
    }
};
</script>
